import React from 'react'
import AgendaHome from '../../Agenda/Home/AgendaHome'
import { Container } from 'reactstrap'

const HomeAgenda = () => {
	return (
		<section 
			className="home-slice home-slice-agenda"
			role="region"
			aria-label="Section agenda de la page d'accueil"
			aria-labelledby="home-agenda-heading"
		>
			<Container>
				<h2 id="home-agenda-heading" className="visually-hidden">
					Agenda des événements
				</h2>
				<AgendaHome />
			</Container>
		</section>
	)
}

export default HomeAgenda
